import { emailIcon } from '../../../../assets';

const Email = ({email, setEmail}) => {
    return (
        <div>
            <label className="block text-xs font-medium text-gray-700 mb-1">
                Correo
            </label>
            <div className="flex items-center border border-gray-300 rounded px-3 py-2 w-full">
                <img src={emailIcon} alt="email" className="w-5 h-5 mr-2" />
                <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="flex-1 outline-none text-xs"
                    placeholder="example@esri.co"
                    required
                />
            </div>
        </div>
    );
};

export default Email;
